import React from 'react';

import CommonModal from '../../../../components/common-modal/CommonModal';
import ProjectsSelect from '../../../../components/projects-select/ProjectsSelect';

import scss from './AssignProjectsModal.module.scss';

function AssignProjectsModal({ isOpen, companyProjects = [], activeProjects = [], onSelect, onClose }) {
  return (
    <CommonModal isOpen={isOpen} onClose={onClose} wrapperClassName={scss.wrapper}>
      <ProjectsSelect
        projectList={companyProjects}
        activeProjects={activeProjects}
        onSelect={onSelect}
        className={scss.projectsSelectWrapper}
      />
    </CommonModal>
  );
}

export default AssignProjectsModal;
